export default __webpack_public_path__ + "static/cska-c453f4157ef3fae22bc4715b26028681.svg";